module.exports = __webpack_public_path__ + "img/logo-megaluzz.5614d901.png";